/**
 * Shopify Forms renders inside Shadow DOM. Theme CSS cannot reach it.
 * This file must load synchronously before {{ content_for_header }} so
 * the Forms loader can adopt window.formStyles into the shadow root.
 */
(function () {
  window.formStyles = window.formStyles || new Map();

  window.formStyles.set(
    'ghc-forms-inputs-buttons',
    `
    :host {
      --form-field-border: none;
      --form-field-border-focused: none;
      --form-field-border-radius: 0px;
      --form-field-padding: 8px;
      --form-field-padding-top: 1.25em;
      --form-field-padding-bottom: 0.5em;
      --button-border-radius: 0px;
      --button-border: none;
      --button-padding: 12px 24px 16px;
      --button-background-color: #191919;
      --button-text-color: #ffffff;
      --form-text-color: #191919;
      --form-placeholder-color: #898989;
      --form-background-color: transparent;
      --container-background-color: #FFFFFF !important;
      --container-border-radius: 0px;
      --container-text-alignment: left;
      --heading-text-color: #A88F60;
      --forms-heading-font: normal 500 14px Futura, sans-serif;
      --forms-heading-font-size: 14px;
      --heading-font-size: 14px;
      --container-max-w: none;
      --forms-padding-top: 48px;
      --forms-padding-right: 56px;
      --forms-padding-bottom: 48px;
      --forms-padding-left: 56px;
    }

    #app-embed:not([data-layout="overlay"]) {
      --container-max-w: 100%;
      --forms-padding-top: 0;
      --forms-padding-right: 0;
      --forms-padding-bottom: 0;
      --forms-padding-left: 0;
      width: 100% !important;
      max-width: 100% !important;
    }

    /* Popup host is pointer-events:none (set in JS); restore hits on teaser/dialog */
    #app-embed[data-layout="overlay"],
    [data-testid="form-teaser"],
    [role="dialog"] {
      pointer-events: auto !important;
    }

    [data-layout="overlay"] [role="dialog"][data-sizing="form-wrapper"] {
      max-width: min(1000px, calc(100vw - 48px)) !important;
      width: min(1000px, calc(100vw - 48px)) !important;
      min-height: 80dvh !important;
      max-height: 100dvh !important;
      overflow-x: hidden !important;
      overflow-y: auto !important;
      overscroll-behavior: contain;
      -webkit-overflow-scrolling: touch;
    }

    [data-layout="overlay"] [class*="_formContainer"][class*="_grid"] {
      display: grid !important;
      grid-template-columns: 1fr 1fr !important;
      overflow-x: hidden !important;
      overflow-y: auto !important;
      min-height: 80dvh !important;
      max-height: 100dvh !important;
      overscroll-behavior: contain;
      -webkit-overflow-scrolling: touch;
    }

    #app-embed:not([data-layout="overlay"]) [class*="_formContainer"][class*="_grid"] {
      display: block !important;
      min-height: 0 !important;
      max-height: none !important;
      height: auto !important;
      overflow: visible !important;
    }

    #app-embed:not([data-layout="overlay"]) [class*="_gridItemContent"] {
      width: 100% !important;
      max-width: none !important;
      box-sizing: border-box !important;
      display: flex !important;
      flex-direction: column !important;
      justify-content: center !important;
      align-items: stretch !important;
      text-align: left !important;
      background-color: transparent !important;
      padding: 0 !important;
      gap: 16px !important;
      min-height: 0 !important;
      height: auto !important;
    }

    [data-layout="overlay"] [class*="_gridItem"][style*="background-image"] {
      min-height: 100% !important;
      background-size: cover !important;
      background-position: center !important;
    }

    [data-layout="overlay"] [class*="_gridItemContent"] {
      width: 100% !important;
      max-width: none !important;
      box-sizing: border-box !important;
      display: flex !important;
      flex-direction: column !important;
      justify-content: center !important;
      align-items: stretch !important;
      text-align: left !important;
      background-color: #FFFFFF !important;
      padding: 56px 48px 40px !important;
      gap: 16px !important;
    }

    [class*="_formHeader"],
    form,
    [class*="_formFieldset"],
    [class*="_formFieldContainer"],
    [class*="_formDisclaimer"] {
      width: 100% !important;
      max-width: none !important;
      text-align: left !important;
    }

    [class*="_formHeader"] {
      flex: none !important;
      margin: 0 !important;
    }

    [class*="_gridItemContent"] > form {
      margin-top: 0 !important;
    }

    [class*="_textBody"] > p {
      margin: 0 0 12px !important;
    }

    [class*="_textBody"] > p:last-child {
      margin-bottom: 0 !important;
    }

    [class*="_formDisclaimer"] {
      margin-top: 8px !important;
      padding-left: 0px !important;
    }

    [class*="_formHeader"],
    [class*="_textBody"],
    [class*="_textBody"] p {
      text-align: left !important;
    }

    [data-layout="overlay"] [class*="_gridItemContent"]:has([data-testid="banner-success"]) {
      align-items: center !important;
      justify-content: center !important;
      text-align: center !important;
      width: 100% !important;
      max-width: none !important;
      grid-column: 1 / -1 !important;
      padding: 64px 48px !important;
      min-height: 360px !important;
    }

    [data-layout="overlay"] [class*="_formContainer"][class*="_grid"]:has([data-testid="banner-success"]),
    [data-layout="overlay"] [class*="_formContainer"][class*="_noImage"] {
      grid-template-columns: 1fr !important;
      grid-template-rows: 1fr !important;
      min-height: 420px !important;
    }

    [data-layout="overlay"] [class*="_formContainer"]:has([data-testid="banner-success"]) > [class*="_gridItem"]:not([class*="_gridItemContent"]),
    [data-layout="overlay"] [class*="_formContainer"][class*="_noImage"] > [class*="_gridItem"]:not([class*="_gridItemContent"]) {
      display: none !important;
    }

    [data-testid="banner-success"],
    [class*="_formBannerContainer"] {
      display: flex !important;
      flex-direction: column !important;
      align-items: center !important;
      justify-content: center !important;
      width: 100% !important;
      max-width: 520px !important;
      margin: 0 auto !important;
      text-align: center !important;
      gap: 16px !important;
    }

    [data-testid="banner-success"] [class*="_formBannerHeading"],
    [class*="_formBannerHeading"] {
      display: block !important;
      width: 100% !important;
      max-width: 420px !important;
      margin: 0 auto !important;
      color: #A88F60 !important;
      font-family: Futura, sans-serif !important;
      font-size: 14px !important;
      font-weight: 500 !important;
      line-height: 120% !important;
      letter-spacing: 2.8px !important;
      text-transform: uppercase !important;
      text-align: center !important;
    }

    [data-testid="banner-success"] [class*="_textBody"],
    [data-testid="banner-success"] [class*="_textBody"] p {
      width: 100% !important;
      max-width: 480px !important;
      margin: 0 auto !important;
      color: #191919 !important;
      font-family: IvyPrestoDisplay, "IvyPresto Display", serif !important;
      font-size: 36px !important;
      font-weight: 100 !important;
      line-height: 120% !important;
      letter-spacing: 0 !important;
      text-align: center !important;
      text-transform: none !important;
    }

    @media only screen and (max-width: 749px) {
      [data-layout="overlay"] [class*="_formContainer"][class*="_grid"] {
        grid-template-columns: 1fr !important;
        grid-template-rows: 1fr !important;
        grid-auto-rows: auto !important;
        min-height: 0 !important;
        height: auto !important;
        align-content: start !important;
      }

      /* Keep the popup near the top so fields stay above the keyboard */
      #app-embed[data-layout="overlay"],
      [data-layout="overlay"] {
        align-items: flex-start !important;
        justify-content: flex-start !important;
        padding-top: max(16px, env(safe-area-inset-top)) !important;
      }

      [data-layout="overlay"] [role="dialog"][data-sizing="form-wrapper"] {
        max-width: 90% !important;
        width: 90% !important;
        min-height: 0 !important;
        height: auto !important;
        max-height: 100dvh !important;
        margin-top: 12px !important;
        margin-bottom: auto !important;
        align-self: flex-start !important;
        top: 0 !important;
        transform: none !important;
      }

      /* Hide popup image on mobile — form fields need the space */
      [data-layout="overlay"] [class*="_formContainer"] > [class*="_gridItem"]:not([class*="_gridItemContent"]) {
        display: none !important;
        height: 0 !important;
        max-height: 0 !important;
        overflow: hidden !important;
        pointer-events: none !important;
      }

      [data-layout="overlay"] [class*="_gridItemContent"] {
        padding: 28px 20px !important;
        min-height: 0 !important;
        height: auto !important;
        justify-content: flex-start !important;
        grid-column: 1 / -1 !important;
      }

      [data-layout="overlay"] [class*="_gridItemContent"]:has([data-testid="banner-success"]) {
        padding: 48px 24px !important;
        justify-content: center !important;
        min-height: 280px !important;
        grid-column: 1 / -1 !important;
      }

      [data-layout="overlay"] [class*="_formContainer"][class*="_grid"]:has([data-testid="banner-success"]),
      [data-layout="overlay"] [class*="_formContainer"][class*="_noImage"] {
        grid-template-columns: 1fr !important;
        grid-template-rows: 1fr !important;
        min-height: 280px !important;
      }

      [data-layout="overlay"] [class*="_formContainer"]:has([data-testid="banner-success"]) > [class*="_gridItem"]:not([class*="_gridItemContent"]),
      [data-layout="overlay"] [class*="_formContainer"][class*="_noImage"] > [class*="_gridItem"]:not([class*="_gridItemContent"]) {
        display: none !important;
        height: 0 !important;
        max-height: 0 !important;
      }

      [data-testid="banner-success"],
      [class*="_formBannerContainer"] {
        max-width: 100% !important;
      }

      [data-testid="banner-success"] [class*="_formBannerHeading"],
      [class*="_formBannerHeading"] {
        font-size: 12px !important;
        letter-spacing: 2px !important;
      }

      [data-testid="banner-success"] [class*="_textBody"],
      [data-testid="banner-success"] [class*="_textBody"] p {
        font-size: 28px !important;
        max-width: 100% !important;
      }

      [class*="_formHeader"] h2,
      h2,
      .ghc-eyebrow-line {
        font-size: 12px !important;
        letter-spacing: 2px !important;
      }

      [class*="_textBody"] > p:first-child {
        font-size: 32px !important;
      }

      [class*="_formContainerCloseButtonPosition"] {
        top: 12px !important;
        right: 12px !important;
        left: auto !important;
      }

      [role="dialog"] [class*="_formCloseButton"] {
        margin: 0 !important;
      }

      #app-embed:not([data-layout="overlay"]),
      #app-embed:not([data-layout="overlay"]) [class*="_formContainer"],
      #app-embed:not([data-layout="overlay"]) [class*="_gridItemContent"],
      #app-embed:not([data-layout="overlay"]) form,
      #app-embed:not([data-layout="overlay"]) [class*="_formFieldset"],
      #app-embed:not([data-layout="overlay"]) [class*="_formFieldContainer"],
      #app-embed:not([data-layout="overlay"]) [class*="_formField"],
      #app-embed:not([data-layout="overlay"]) [class*="_formDisclaimer"] {
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        box-sizing: border-box !important;
      }

      #app-embed:not([data-layout="overlay"]) [class*="_formFieldset"] > div:has([class*="_formFieldContainer"]:nth-child(3)),
      #app-embed:not([data-layout="overlay"]) [class*="_formFieldContainer"]:has(input[placeholder="MM"]),
      #app-embed:not([data-layout="overlay"]) [class*="_formFieldContainer"]:has(input[placeholder="DD"]),
      #app-embed:not([data-layout="overlay"]) [class*="_formFieldContainer"]:has(input[placeholder="YYYY"]),
      #app-embed:not([data-layout="overlay"]) [class*="_formFieldContainer"]:has(input[autocomplete="bday-month"]),
      #app-embed:not([data-layout="overlay"]) [class*="_formFieldContainer"]:has(input[autocomplete="bday-day"]),
      #app-embed:not([data-layout="overlay"]) [class*="_formFieldContainer"]:has(input[autocomplete="bday-year"]) {
        min-width: 0 !important;
        max-width: 100% !important;
        flex: 1 1 0 !important;
      }

      #app-embed:not([data-layout="overlay"]) input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]),
      #app-embed:not([data-layout="overlay"]) select,
      #app-embed:not([data-layout="overlay"]) textarea:not([name^="h-captcha"]) {
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        box-sizing: border-box !important;
      }

      #app-embed:not([data-layout="overlay"]) button[type="submit"],
      #app-embed:not([data-layout="overlay"]) [data-testid="btn-form-submit"] {
        display: flex !important;
        box-sizing: border-box !important;
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        align-self: stretch !important;
        justify-content: center !important;
        align-items: center !important;
        text-align: center !important;
        letter-spacing: 0 !important;
        overflow: hidden !important;
      }

      #app-embed:not([data-layout="overlay"]) .ghc-form-submit-content,
      #app-embed:not([data-layout="overlay"]) .ghc-form-submit-label {
        display: inline-flex !important;
        flex: 0 0 auto !important;
        width: auto !important;
        max-width: 100% !important;
        min-width: 0 !important;
        margin: 0 !important;
        transform: none !important;
        justify-content: center !important;
        align-items: center !important;
      }
    }

    [data-testid="form-teaser"],
    [data-testid="form-teaser"] h3,
    [class*="_teaserHeading"] {
      color: #191919 !important;
    }

    [class*="_formHeader"] h2,
    h2 {
      display: flex !important;
      flex-direction: column !important;
      align-items: flex-start !important;
      gap: 6px !important;
      color: #A88F60 !important;
      font-family: Futura, sans-serif !important;
      font-size: 14px !important;
      font-style: normal !important;
      font-weight: 500 !important;
      line-height: 120% !important;
      letter-spacing: 2.4px !important;
      text-transform: uppercase !important;
    }

    .ghc-eyebrow-line {
      display: block !important;
      font-size: 14px !important;
      font-weight: 500 !important;
      letter-spacing: 2.4px !important;
    }

    [class*="_textBody"] > p:first-child {
      color: #191919 !important;
      font-family: IvyPrestoDisplay, "IvyPresto Display", serif !important;
      font-size: 48px !important;
      font-style: normal !important;
      font-weight: 100 !important;
      line-height: 110% !important;
      letter-spacing: 0 !important;
      text-transform: none !important;
      leading-trim: both;
      text-edge: cap;
    }

    [class*="_textBody"] > p:not(:first-child) {
      color: #191919 !important;
      font-family: "Inter", sans-serif !important;
      font-size: 14px !important;
      font-style: normal !important;
      font-weight: 300 !important;
      line-height: 150% !important;
      letter-spacing: 0 !important;
      text-transform: none !important;
    }

    [data-sizing="form-wrapper"][role="dialog"],
    [role="dialog"].withImage,
    [role="dialog"] [style*="background-image"] {
      border-radius: 0 !important;
    }

    input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]),
    select,
    textarea:not([name^="h-captcha"]) {
      appearance: none;
      -webkit-appearance: none;
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      box-sizing: border-box !important;
      background: transparent !important;
      background-color: transparent !important;
      border: 1px solid #DADAD9 !important;
      border-radius: 0 !important;
      box-shadow: none !important;
      outline: none !important;
      color: #191919 !important;
      font-family: "Inter", sans-serif !important;
      font-weight: 300 !important;
      font-size: 16px !important;
      line-height: 1.5 !important;
      padding: 13px 14px !important;
      min-height: 46px;
    }

    input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]):hover,
    input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]):focus,
    input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]):focus-visible,
    select:hover,
    select:focus,
    select:focus-visible,
    textarea:not([name^="h-captcha"]):hover,
    textarea:not([name^="h-captcha"]):focus,
    textarea:not([name^="h-captcha"]):focus-visible {
      background: transparent !important;
      border: 1px solid #191919 !important;
      box-shadow: none !important;
      outline: none !important;
    }

    input::placeholder,
    textarea::placeholder {
      color: #898989 !important;
      font-family: "Inter", sans-serif !important;
      font-weight: 300 !important;
      opacity: 1;
    }

    label[id^="label-"] {
      font-family: "Inter", sans-serif !important;
      font-weight: 300 !important;
      color: #898989 !important;
      left: 14px !important;
      padding-left: 2px !important;
      transition: opacity 0.15s ease, visibility 0.15s ease;
    }

    [class*="_formFieldContainer"].ghc-input-active label[id^="label-"],
    [class*="_formFieldContainer"]:has(input:focus) label[id^="label-"] {
      opacity: 0 !important;
      visibility: hidden !important;
      pointer-events: none !important;
    }

    button[type="submit"],
    [data-testid="btn-form-submit"] {
      display: inline-flex !important;
      box-sizing: border-box !important;
      align-items: center !important;
      justify-content: center !important;
      width: fit-content !important;
      max-width: fit-content !important;
      align-self: flex-start !important;
      min-width: 0 !important;
      margin-top: 8px;
      border: none !important;
      border-radius: 0 !important;
      box-shadow: none !important;
      background-color: #191919 !important;
      color: #ffffff !important;
      font-family: "Futura", sans-serif !important;
      font-weight: 500 !important;
      font-size: 13px !important;
      line-height: 1.2 !important;
      letter-spacing: 0 !important;
      text-transform: uppercase !important;
      padding: 12px 24px 16px !important;
      cursor: pointer;
    }

    .ghc-form-submit-content {
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
    }

    .ghc-form-submit-label {
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      gap: 8px !important;
      padding: 6px 0 !important;
      border-bottom: 1px solid #A88F60 !important;
    }

    .ghc-form-submit-text {
      color: #ffffff !important;
      font-family: "Futura", sans-serif !important;
      font-weight: 500 !important;
      font-size: 13px !important;
      line-height: 1.2 !important;
      letter-spacing: 2.4px !important;
      text-transform: uppercase !important;
    }

    .ghc-form-submit-chevron {
      color: #A88F60 !important;
      font-family: "Futura", sans-serif !important;
      font-weight: 500 !important;
      font-size: 13px !important;
      line-height: 1 !important;
      letter-spacing: 0 !important;
      text-transform: none !important;
    }

    button[type="submit"]:hover,
    button[type="submit"]:focus-visible,
    [data-testid="btn-form-submit"]:hover,
    [data-testid="btn-form-submit"]:focus-visible {
      background-color: #191919 !important;
      opacity: 0.85;
    }

    @media only screen and (min-width: 750px) {
      input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]),
      select,
      textarea:not([name^="h-captcha"]) {
        font-size: 14px !important;
        padding: 14px !important;
        min-height: 48px;
      }

      button[type="submit"],
      [data-testid="btn-form-submit"] {
        font-size: 13px !important;
        letter-spacing: 2.4px !important;
      }

      .ghc-form-submit-text,
      .ghc-form-submit-chevron {
        font-size: 14px !important;
        letter-spacing: 2.8px !important;
      }

      .ghc-form-submit-chevron {
        letter-spacing: 0 !important;
      }

      .ghc-eyebrow-line,
      h2 {
        font-size: 15px !important;
        font-weight: 500 !important;
        letter-spacing: 2.8px !important;
      }

      [class*="_textBody"] > p:first-child {
        font-size: 75px !important;
      }

      [class*="_textBody"] > p:not(:first-child) {
        font-size: 15px !important;
      }

      [data-testid="banner-success"] [class*="_textBody"],
      [data-testid="banner-success"] [class*="_textBody"] p {
        font-size: 48px !important;
        max-width: 520px !important;
      }

      [data-testid="banner-success"] [class*="_formBannerHeading"],
      [class*="_formBannerHeading"] {
        font-size: 15px !important;
      }
    }
    `
  );

  function enhanceFormInputs(shadowRoot) {
    shadowRoot
      .querySelectorAll('input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"])')
      .forEach(function (input) {
        if (input.dataset.ghcInputEnhanced) return;

        var container = input.closest('[class*="_formFieldContainer"]');
        if (!container) return;

        function syncLabel() {
          var hideLabel =
            document.activeElement === input || (input.value && input.value.length > 0);
          container.classList.toggle('ghc-input-active', hideLabel);
        }

        input.addEventListener('input', syncLabel);
        input.addEventListener('focus', syncLabel);
        input.addEventListener('blur', syncLabel);
        syncLabel();
        input.dataset.ghcInputEnhanced = 'true';
      });
  }

  // Meta Pixel / GTM cannot target Shadow DOM buttons via click rules.
  // Listen inside the shadow root and fire pixel + dataLayer ourselves.
  var lastMetaFormTrackAt = 0;

  function pushFormsTrackingEvent(formType) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'get_10_percent_off_button_click',
      form_type: formType,
      content_name: 'Get 10% Off',
    });
  }

  function fireMetaFormEvents(formType) {
    var payload = {
      content_name: 'Get 10% Off',
      form_type: formType,
    };

    function send(fbq) {
      fbq('track', 'Lead', payload);
      fbq('trackCustom', 'Get 10% Off Button Click', payload);
    }

    if (typeof window.fbq === 'function') {
      send(window.fbq);
      return true;
    }

    // Pixel is injected by GTM asynchronously — retry briefly if not ready yet.
    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (typeof window.fbq === 'function') {
        window.clearInterval(timer);
        send(window.fbq);
      } else if (attempts >= 25) {
        window.clearInterval(timer);
        if (window.console && typeof window.console.warn === 'function') {
          console.warn(
            '[GHC Forms] Meta pixel (fbq) not available after submit click. Is the pixel loaded via GTM/consent?'
          );
        }
      }
    }, 100);

    return false;
  }

  function trackMetaFormSubmit(shadowRootOrEmbed) {
    var now = Date.now();
    if (now - lastMetaFormTrackAt < 1000) return;
    lastMetaFormTrackAt = now;

    var embed =
      shadowRootOrEmbed && shadowRootOrEmbed.host
        ? shadowRootOrEmbed.host
        : shadowRootOrEmbed;
    var formType = embed && isInlineFormsEmbed(embed) ? 'inline' : 'popup';

    pushFormsTrackingEvent(formType);
    fireMetaFormEvents(formType);

    if (window.console && typeof window.console.info === 'function') {
      console.info('[GHC Forms] Submit tracking fired', {
        form_type: formType,
        fbq: typeof window.fbq,
      });
    }
  }

  function eventTargetIsSubmitControl(target) {
    if (!target) return false;
    var node = target.nodeType === 1 ? target : target.parentElement;
    while (node) {
      if (node.matches) {
        if (
          node.matches('button[type="submit"], [data-testid="btn-form-submit"]') ||
          (node.tagName === 'BUTTON' && node.type === 'submit')
        ) {
          return true;
        }
      }
      if (node.tagName === 'FORM' || node.nodeType === 11) break;
      node = node.parentElement || node.parentNode;
    }
    return false;
  }

  function findFormsSubmitFromEvent(event) {
    var path = typeof event.composedPath === 'function' ? event.composedPath() : [];
    if (!path.length && event.target) path = [event.target];

    var submitControl = null;
    var embed = null;

    for (var i = 0; i < path.length; i++) {
      var node = path[i];
      if (!node || node.nodeType !== 1) continue;

      if (
        !submitControl &&
        node.matches &&
        (node.matches('button[type="submit"], [data-testid="btn-form-submit"]') ||
          (node.tagName === 'BUTTON' && node.type === 'submit'))
      ) {
        submitControl = node;
      }

      if (node.tagName === 'SHOPIFY-FORMS-EMBED') {
        embed = node;
        break;
      }
    }

    if (!submitControl || !embed) return null;
    return embed;
  }

  function enhanceFormTracking(shadowRoot) {
    if (!shadowRoot || shadowRoot.ghcMetaDelegated) return;
    shadowRoot.ghcMetaDelegated = true;

    shadowRoot.addEventListener(
      'click',
      function (event) {
        if (eventTargetIsSubmitControl(event.target)) {
          trackMetaFormSubmit(shadowRoot);
        }
      },
      true
    );

    shadowRoot.addEventListener(
      'submit',
      function () {
        trackMetaFormSubmit(shadowRoot);
      },
      true
    );
  }

  // Fallback that does not depend on per-embed observers (Shadow DOM can upgrade
  // after we first see the host, with no light-DOM mutation to re-run watchEmbeds).
  document.addEventListener(
    'click',
    function (event) {
      var embed = findFormsSubmitFromEvent(event);
      if (embed) trackMetaFormSubmit(embed);
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var embed = findFormsSubmitFromEvent(event);
      if (embed) trackMetaFormSubmit(embed);
    },
    true
  );

  function enhanceSubmitButton(shadowRoot) {
    var button = shadowRoot.querySelector('button[type="submit"], [data-testid="btn-form-submit"]');
    if (!button) return;
    if (button.dataset.ghcEnhanced && button.querySelector('.ghc-form-submit-label')) return;

    var text = button.textContent.replace(/\s*[>›→]+\s*$/, '').trim();
    if (!text) return;

    button.innerHTML =
      '<span class="ghc-form-submit-content">' +
      '<span class="ghc-form-submit-label">' +
      '<span class="ghc-form-submit-text">' +
      text +
      '</span><span class="ghc-form-submit-chevron" aria-hidden="true">&gt;</span>' +
      '</span></span>';
    button.dataset.ghcEnhanced = 'true';
  }

  function splitPopupEyebrow(shadowRoot) {
    var header = shadowRoot.querySelector('[class*="_formHeader"] h2');
    if (!header || header.dataset.ghcSplit) return;

    var text = header.textContent.replace(/\s+/g, ' ').trim();
    var questionIndex = text.indexOf('?');
    if (questionIndex === -1) return;

    var firstLine = text.slice(0, questionIndex + 1).trim();
    var secondLine = text.slice(questionIndex + 1).trim();
    if (!secondLine) return;

    header.innerHTML =
      '<span class="ghc-eyebrow-line ghc-eyebrow-line--primary">' +
      firstLine +
      '</span><span class="ghc-eyebrow-line ghc-eyebrow-line--secondary">' +
      secondLine +
      '</span>';
    header.dataset.ghcSplit = 'true';
  }

  // TEMP: allow all Forms embeds while debugging blank inline form.
  // Restore by returning the classList check below.
  var GHC_TEMP_ALLOW_ALL_FORMS = true;

  function shouldHideFormsPopup() {
    if (GHC_TEMP_ALLOW_ALL_FORMS) return false;
    return !!(document.body && document.body.classList.contains('ghc-hide-forms-popup'));
  }

  function isInlineFormsEmbed(embed) {
    return !!(
      embed.closest('.half-media-text') ||
      embed.closest('.half-media-text__app-block')
    );
  }

  function revealInlineFormsEmbed(embed) {
    embed.classList.add('ghc-forms-inline-protected');
    embed.removeAttribute('hidden');
    embed.removeAttribute('aria-hidden');
    // Inline !important wins over the newsletter hide-all rule and any
    // previous suppressPopupEmbeds() display:none stamp.
    embed.style.setProperty('display', 'block', 'important');
    embed.style.setProperty('visibility', 'visible', 'important');
  }

  function protectInlineFormsEmbed(embed) {
    if (!isInlineFormsEmbed(embed) || embed.dataset.ghcInlineProtected) return;

    revealInlineFormsEmbed(embed);
    embed.dataset.ghcInlineProtected = 'true';

    new MutationObserver(function () {
      if (!isInlineFormsEmbed(embed)) return;
      if (
        embed.hasAttribute('hidden') ||
        embed.getAttribute('aria-hidden') === 'true' ||
        embed.style.display === 'none' ||
        !embed.classList.contains('ghc-forms-inline-protected')
      ) {
        revealInlineFormsEmbed(embed);
      }
    }).observe(embed, {
      attributes: true,
      attributeFilter: ['hidden', 'aria-hidden', 'style', 'class'],
    });
  }

  function isOverlayPopupEmbed(embed) {
    if (!embed.shadowRoot) return false;
    return !!embed.shadowRoot.querySelector('#app-embed[data-layout="overlay"]');
  }

  function isPopupFormsEmbed(embed) {
    if (isInlineFormsEmbed(embed) || !embed.shadowRoot) return false;
    return !!(
      isOverlayPopupEmbed(embed) ||
      embed.shadowRoot.querySelector('[data-testid="form-teaser"]')
    );
  }

  // ScrollSmoother transforms #smooth-content, so a fixed teaser inside it
  // (or a host at the document bottom) makes the first mobile tap scroll the
  // page instead of opening the form. Pin popup hosts to the viewport.
  function pinPopupEmbedHost(embed) {
    if (!isPopupFormsEmbed(embed) || embed.dataset.ghcPopupPinned) return;

    var wrapper = document.getElementById('smooth-wrapper');
    if (wrapper && wrapper.contains(embed) && embed.parentNode) {
      document.body.appendChild(embed);
    }

    embed.style.setProperty('position', 'fixed', 'important');
    embed.style.setProperty('inset', '0px', 'important');
    embed.style.setProperty('width', '100%', 'important');
    embed.style.setProperty('height', '100%', 'important');
    embed.style.setProperty('pointer-events', 'none', 'important');
    embed.style.setProperty('z-index', '999999', 'important');
    embed.dataset.ghcPopupPinned = 'true';
  }

  function suppressPopupEmbeds() {
    document.querySelectorAll('shopify-forms-embed').forEach(function (embed) {
      if (isInlineFormsEmbed(embed)) {
        protectInlineFormsEmbed(embed);
        revealInlineFormsEmbed(embed);
        return;
      }

      pinPopupEmbedHost(embed);

      if (!shouldHideFormsPopup()) return;

      // Only hide confirmed popup overlays. Avoid permanently hiding unknown
      // embeds with inline !important before they're classified.
      if (!isOverlayPopupEmbed(embed)) return;

      embed.setAttribute('hidden', '');
      embed.setAttribute('aria-hidden', 'true');
    });
  }

  function enhancePopupForms() {
    suppressPopupEmbeds();

    document.querySelectorAll('shopify-forms-embed').forEach(function (embed) {
      if (!embed.shadowRoot) return;
      if (shouldHideFormsPopup() && !isInlineFormsEmbed(embed)) return;

      pinPopupEmbedHost(embed);
      splitPopupEyebrow(embed.shadowRoot);
      enhanceSubmitButton(embed.shadowRoot);
      enhanceFormInputs(embed.shadowRoot);
      enhanceFormTracking(embed.shadowRoot);
    });
  }

  function overlayFormIsOpen() {
    if (shouldHideFormsPopup()) return false;

    var embed = document.querySelector('shopify-forms-embed');
    if (!embed || !embed.shadowRoot) return false;
    var overlay = embed.shadowRoot.querySelector('#app-embed[data-layout="overlay"]');
    if (!overlay) return false;
    if (overlay.getAttribute('data-current-step') === 'teaser') return false;
    return !!embed.shadowRoot.querySelector(
      '[role="dialog"][data-sizing="form-wrapper"]'
    );
  }

  function keepScrollOnForm(event) {
    if (!overlayFormIsOpen()) return;
    event.stopImmediatePropagation();
    if (window.scrollSmoother) window.scrollSmoother.paused(true);
  }

  document.addEventListener('wheel', keepScrollOnForm, true);
  document.addEventListener('touchmove', keepScrollOnForm, true);

  function syncSmoother() {
    if (!window.scrollSmoother) return;
    window.scrollSmoother.paused(overlayFormIsOpen());
  }

  var watched = [];
  function watchEmbeds() {
    suppressPopupEmbeds();

    document.querySelectorAll('shopify-forms-embed').forEach(function (embed) {
      if (shouldHideFormsPopup() && !isInlineFormsEmbed(embed)) return;

      pinPopupEmbedHost(embed);

      // Shadow root can appear after the host is first seen, without another
      // light-DOM mutation — only mark watched once we can enhance it.
      if (!embed.shadowRoot) return;
      if (watched.indexOf(embed) !== -1) {
        enhanceFormTracking(embed.shadowRoot);
        return;
      }

      watched.push(embed);
      splitPopupEyebrow(embed.shadowRoot);
      enhanceSubmitButton(embed.shadowRoot);
      enhanceFormInputs(embed.shadowRoot);
      enhanceFormTracking(embed.shadowRoot);
      new MutationObserver(function () {
        pinPopupEmbedHost(embed);
        splitPopupEyebrow(embed.shadowRoot);
        enhanceSubmitButton(embed.shadowRoot);
        enhanceFormInputs(embed.shadowRoot);
        enhanceFormTracking(embed.shadowRoot);
        syncSmoother();
      }).observe(embed.shadowRoot, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['data-current-step', 'class', 'style'],
      });
    });
    enhancePopupForms();
    syncSmoother();
  }

  new MutationObserver(watchEmbeds).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
  watchEmbeds();
})();
